import { render, staticRenderFns } from "./HowItWorksWidget.vue?vue&type=template&id=304ddbe8&scoped=true"
import script from "./HowItWorksWidget.vue?vue&type=script&lang=ts"
export * from "./HowItWorksWidget.vue?vue&type=script&lang=ts"
import style0 from "./HowItWorksWidget.vue?vue&type=style&index=0&id=304ddbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304ddbe8",
  null
  
)

export default component.exports